// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@eisinc/App/Store/Reducers";
import { ButtonPresentationProps } from "@eisinc/MobiusOverrides/Button";
import TwoButtonModal, { TwoButtonModalStyles } from "@eisinc/Overrides/Components/TwoButtonModal";
import { modalButtonsActionStyles } from "@eisinc/XDL/Utilities";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";

export interface OwnProps {
    handleCancel?: () => void;
    handleContinue: () => void;
}

const mapStateToProps = (state: CustomAppState) => {
    return {
        isModalOpen: !!state.xCommon.isChangeScheduleModalOpen,
    };
};

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ChangeScheduleModalStyles {
    twoButtonModal?: TwoButtonModalStyles;
    buttonsWrapper?: InjectableCss;
    cancelButton?: ButtonPresentationProps;
    continueButton?: ButtonPresentationProps;
}

export const changeScheduleModalStyles: ChangeScheduleModalStyles = {
    cancelButton: { ...modalButtonsActionStyles.cancelButton },
    continueButton: { ...modalButtonsActionStyles.submitButton },
    twoButtonModal: {
        modal: {
            sizeVariant: "small",
        },
    },
};

const styles = changeScheduleModalStyles;

const ChangeScheduleModal: React.FC<Props> = ({ isModalOpen, handleCancel, handleContinue }) => {
    const dispatch = useAppDispatch();

    const handleCancelClick = () => {
        dispatch({ type: "xCommon/update", data: { key: "isChangeScheduleModalOpen", value: false } });
        handleCancel && handleCancel();
    };

    const handleContinueClick = () => {
        handleContinue();
    };

    return (
        <TwoButtonModal
            modalIsOpen={isModalOpen}
            headlineText={siteMessage("Change_Shipment_Schedule_Header")}
            messageText={siteMessage("Change_Shipment_Schedule_Copy")}
            cancelButtonText={translate("Cancel")}
            submitButtonText={translate("Change Shipment Schedule")}
            onCancel={handleCancelClick}
            onSubmit={handleContinueClick}
            extendedStyles={styles.twoButtonModal}
        ></TwoButtonModal>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeScheduleModal);
